import React from 'react';
import './TermsOfServicePage.css';

const TermsOfServicePage = () => {
  const lastUpdated = "2025, December 18";

  return (
    <div className="terms-page">
      <div className="terms-container">
        <div className="terms-header">
          <h1 className="terms-title">Terms of Service</h1>
          <div className="last-updated">
            Last updated: <strong>{lastUpdated}</strong>
          </div>
          <p className="terms-intro">
            Welcome to CBC Center. By accessing or using our platform, you agree to be bound by these 
            Terms of Service. Please read them carefully before using our services.
          </p>
        </div>

        <div className="terms-content">
          <section className="terms-section">
            <h2 className="section-title">1. Acceptance of Terms</h2>
            <p>
              By accessing and using CBC Center, you accept and agree to be bound by the terms and 
              conditions of this agreement. If you do not agree to these terms, please do not use 
              our platform.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="section-title">2. Service Description</h2>
            <p>
              CBC Center provides educational resources including:
            </p>
            <ul>
              <li>Curriculum-aligned learning materials</li>
              <li>Past examination papers and revision questions</li>
              <li>Teaching guides and lesson plans</li>
              <li>Educational tools and resources</li>
            </ul>
            <p>
              All resources are provided free of charge for educational purposes.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="section-title">3. User Responsibilities</h2>
            <p>When using our platform, you agree to:</p>
            <div className="responsibility-grid">
              <div className="responsibility-item">
                <span className="responsibility-icon">✓</span>
                <div>
                  <h4>Proper Use</h4>
                  <p>Use resources only for educational purposes</p>
                </div>
              </div>
              <div className="responsibility-item">
                <span className="responsibility-icon">✓</span>
                <div>
                  <h4>Respect Copyright</h4>
                  <p>Do not redistribute or sell our materials</p>
                </div>
              </div>
              <div className="responsibility-item">
                <span className="responsibility-icon">✓</span>
                <div>
                  <h4>No Commercial Use</h4>
                  <p>Do not use resources for commercial gain</p>
                </div>
              </div>
              <div className="responsibility-item">
                <span className="responsibility-icon">✓</span>
                <div>
                  <h4>Attribution</h4>
                  <p>Acknowledge CBC Center when using our materials</p>
                </div>
              </div>
            </div>
          </section>

          <section className="terms-section">
            <h2 className="section-title">4. Intellectual Property</h2>
            <p>
              All content, materials, and resources on CBC Center are protected by copyright and 
              other intellectual property laws. Unless otherwise stated, CBC Center owns the 
              intellectual property rights for all material on the platform.
            </p>
            <p>
              You may download and use resources for personal, non-commercial educational purposes, 
              but you may not:
            </p>
            <ul>
              <li>Republish material from CBC Center</li>
              <li>Sell, rent, or sub-license material from CBC Center</li>
              <li>Reproduce, duplicate, or copy material from CBC Center for commercial purposes</li>
              <li>Redistribute content from CBC Center</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2 className="section-title">5. User-Generated Content</h2>
            <p>
              Users may have the opportunity to submit content to CBC Center. By submitting content, 
              you grant us a non-exclusive, worldwide, royalty-free license to use, modify, and 
              distribute the content for educational purposes.
            </p>
            <p>
              You are responsible for ensuring that any content you submit:
            </p>
            <ul>
              <li>Is accurate and truthful</li>
              <li>Does not violate any third-party rights</li>
              <li>Is appropriate for educational purposes</li>
              <li>Complies with all applicable laws</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2 className="section-title">6. Limitation of Liability</h2>
            <p>
              CBC Center and its contributors shall not be held liable for any indirect, incidental, 
              special, consequential, or punitive damages resulting from:
            </p>
            <ul>
              <li>Your use or inability to use the service</li>
              <li>Any errors or omissions in the content</li>
              <li>Unauthorized access to or use of our servers</li>
              <li>Any interruption or cessation of transmission to or from our service</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2 className="section-title">7. Disclaimer</h2>
            <p>
              The resources on CBC Center are provided "as is" without any warranties, express or 
              implied. We do not guarantee that:
            </p>
            <ul>
              <li>The content is error-free or complete</li>
              <li>The service will be uninterrupted or available at all times</li>
              <li>The content will meet your specific requirements</li>
            </ul>
            <p>
              While we strive to provide accurate and up-to-date information, we recommend 
              consulting official curriculum documents for definitive guidance.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="section-title">8. Changes to Terms</h2>
            <p>
              We reserve the right to modify these terms at any time. We will notify users of 
              significant changes by posting the updated terms on this page and updating the 
              "Last updated" date.
            </p>
            <p>
              Your continued use of CBC Center after any changes constitutes your acceptance 
              of the updated terms.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="section-title">9. Governing Law</h2>
            <p>
              These Terms shall be governed and construed in accordance with the laws of Kenya, 
              without regard to its conflict of law provisions.
            </p>
            <p>
              Any disputes arising from these Terms shall be subject to the exclusive jurisdiction 
              of the courts of Kenya.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfServicePage;